import { useParams } from 'react-router-dom';

import DocumentationScreen from '../../features/documentation/layouts/documentation';

// TSS vite/01 §"Pages are thin" — read the URL, mount a feature.
//
//   /admin/documentation                  → the section, on API Reference
//   /admin/documentation/api-reference    → a project's API reference, ?project=

export default function DocumentationPage() {
    const { tab } = useParams();
    return <DocumentationScreen tab={tab} />;
}
